import React, { useEffect } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import { TOGGLE_CLAIM_TYPE_WARNING_POPUP } from "./reducers/audit-properties-reducer";
import MdaeButton from "../../common_components/common_widgets/button";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";

export const toggleClaimTypeWarningPopup = (isVisible, dispatch) => {
  dispatch({
    type: TOGGLE_CLAIM_TYPE_WARNING_POPUP,
    data: {
      isClaimTypeWarningPopupVisible: isVisible
    },
  });
}


const ClaimTypeWarningPopup: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const auditCasesList = useSelector(
    (state) => state["externalAuditReducer"].auditCasesList,
    isEqual
  );

  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );

  const getCasesCount = () => {
    let count = auditCasesList?.filter(x => x.claimTypeCd?.toUpperCase() !== auditPropertiesData?.claimTypeCd?.toUpperCase() && auditPropertiesData.claimTypeCd?.toUpperCase() !== 'A');
    return count?.length;
  }

  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          props.onCancelClaimTypeWarning();
          toggleClaimTypeWarningPopup(false, dispatch);
        }}
      >
        Warning
      </MdaePopupTitle>
    );
  };
  return (
    <div>
      <MdaePopup
        deferRendering={false}
        width={400}
        height={200}
        className="-warning-popup"
        mdaeTitleRender={getPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_CLAIM_TYPE_WARNING_POPUP,
            reducerName: "auditPropertiesReducer",
            widgetOptionBindings: {
              visible: "isClaimTypeWarningPopupVisible",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div className="message-section">
                  {getCasesCount()} case(s) do not match the new claim type. Do you want to continue?
                </div>
              </MdaePopupContent>
            </div>
          )
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupSecondaryButton"}
                  role={"secondary"}
                  onClick={() => {
                    props.onCancelClaimTypeWarning();
                    toggleClaimTypeWarningPopup(false, dispatch);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupPrimaryButton"}
                  role={"primary"}
                  onClick={() => {
                    toggleClaimTypeWarningPopup(false, dispatch);
                  }}
                >
                  Ok
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          )
        }}
      >

      </MdaePopup>
    </div>
  )

}

export default ClaimTypeWarningPopup;